var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeTagCst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 11.4062C20.0938 11.8125 20.0938 12.4375 19.6875 12.8438L16.8125 15.7188C16.4062 16.125 15.7812 16.125 15.375 15.7188L12.5625 12.9062C12.1875 12.5312 11.9688 12.0312 11.9688 11.5V9C11.9688 8.46875 12.4375 8 12.9688 8H15.4688C16 8 16.5 8.21875 16.875 8.59375L19.6875 11.4062ZM13.9688 10.75C14.4062 10.75 14.7188 10.4375 14.7188 10C14.7188 9.59375 14.4062 9.25 13.9688 9.25C13.5625 9.25 13.2188 9.59375 13.2188 10C13.2188 10.4375 13.5625 10.75 13.9688 10.75ZM7 8C4.78125 8 3 6.21875 3 4C3 1.8125 4.78125 0 7 0C9.1875 0 11 1.8125 11 4C11 6.21875 9.1875 8 7 8ZM10.9688 11.5C10.9688 12.2812 11.2812 13.0312 11.8438 13.5938L13.6562 15.4062C13.4062 15.7812 12.9688 16 12.5 16H1.5C0.65625 16 0 15.3438 0 14.5V13.2188C0 10.9062 1.875 9 4.1875 9H4.71875C5.40625 9.3125 6.1875 9.5 7 9.5C7.8125 9.5 8.5625 9.3125 9.25 9H9.78125C10.1875 9 10.5938 9.09375 10.9688 9.1875V11.5Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeTagCst);
export default __webpack_public_path__ + "static/media/type_tag_cst.564c0effa15f785c93e09b1cf229db58.svg";
export { ForwardRef as ReactComponent };